module.exports = __webpack_public_path__ + "static/img/image2_qyjs.c0033c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PC/image2_qyjs.png
// module id = beRq
// module chunks = 1